export const STATE_KEY = 'customerDetails'

export const SET_CUSTOMER_DETAILS = 'SET_CUSTOMER_DETAILS'
export const SET_CUSTOMER_DETAILS_LOADING = 'SET_CUSTOMER_DETAILS_LOADING'
export const SET_CUSTOMER_DETAILS_ERROR = 'SET_CUSTOMER_DETAILS_ERROR'
export const SET_CUSTOMER_DETAILS_NOT_FOUND = 'SET_CUSTOMER_DETAILS_NOT_FOUND'
export const CLEAR_CUSTOMER_DETAILS = 'CLEAR_CUSTOMER_DETAILS'

const initialState = {
  loading: false,
  hasLoaded: false,
  error: null,
  notFound: false,
  customerId: null,
  customer: null,
  vehicles: [],
  previouslyOwnedVehicles: [],
  serviceHistory: [],
  serviceMeta: null,
  warranties: null,
  communications: null,
  lifetimeValue: null,
  ltvComponents: null,
  vehicleDetails: {},
  visitHistory: [],
  visitClickPaths: [],
  financing: null,
  narratives: null,
  wants: [],
  dealShapeLine: null,
  wantsNarrative: null,
}

export default function customerDetailsReducers(state = initialState, action) {
  switch (action.type) {
    case SET_CUSTOMER_DETAILS_LOADING:
      return { ...state, loading: true, error: null, notFound: false, customerId: action.payload }

    case SET_CUSTOMER_DETAILS:
      return {
        ...state,
        loading: false,
        hasLoaded: true,
        error: null,
        ...action.payload,
      }

    case SET_CUSTOMER_DETAILS_ERROR:
      return { ...state, loading: false, hasLoaded: true, error: action.payload }

    case SET_CUSTOMER_DETAILS_NOT_FOUND:
      return { ...state, loading: false, hasLoaded: true, notFound: true }

    case CLEAR_CUSTOMER_DETAILS:
      return { ...initialState }

    default:
      return state
  }
}
